const getSavedRefreshToken = () => {
  const refreshToken = JSON.parse(sessionStorage.getItem('refreshToken')) || '';
  return refreshToken;
};

export default getSavedRefreshToken;
